export default "__VITE_ASSET__CGAwhcre__"